import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const COMMISSION_APPLICATIONS_URL = `${SERVER_API}/commissions/applications`;

export const COMMISSION_MEETINGS_URL = `${SERVER_API}/commissions/meeting`;

/** Протокол (решение комиссии): add/remove пунктов по заявке */
export const COMMISSION_DECISION_URL = `${SERVER_API}/commissions/decision`;

export const COMMISSION_DECISION_PARAGRAPHS_URL = `${SERVER_API}/commissions/decision-paragraph`;

export const COMMISSION_DECISION = {
  GENERATE_PROTOCOL(commissionDecisionId: number | string): IEndpointData {
    return {
      method: 'POST',
      url: `${COMMISSION_DECISION_URL}/${commissionDecisionId}/generate-protocol`,
    };
  },
};
